module.exports = __webpack_public_path__ + "static/video-demo-949772c701bde08ab0d926153e394279.gif";